import fr from 'vuetify/lib/locale/fr'

export default {
    ...fr,

    app: {
        dashboard: "Tableau de bord",
        alarms: "Alarmes",
        screenshots: "Captures d'écran",
        users: "Utilisateurs",
        account: "Compte",
        organizations: "Organisations",
        support: "Aide & Contact",
        logout: "Se déconnecter",
    },

    login: {
        loginError: "Email / Mot de passe incorrect",
        noOrganization: "Votre compte n'est associé à aucune organisation. Merci de bien vouloir contacter le support UTC-SYSTEM pour plus de renseignements.",
        passwordResetSendOK: "Seulement si le compte existe, le lien pour le changement de mot de passe est envoyé par e-mail",
        passwordUpdated: "Mot de passe mis à jour",
    },

    signIn: {
        required: "Champ requis",
        verificationCode: "Code de vérification",
        validate: "Valider",
        cancel: "Annuler",
        email: "Adresse électronique",
        username: "Nom d'utilisateur",
        phonenumbermustbevalid: "Le numéro de téléphone doit être valide",
        newpassword: "Nouveau mot de passe",
        passwordconfirmation: "Confirmation du mot de passe",
        nameisrequired: "Le nom est requis",
        passwordisrequired: "Le nouveau mot de pase est obligatoire",
        yourpasswordshouldcontainatleastoneuppercase: "Le mot de passe doit contenir au moins une majuscule",
        yourpasswordshouldcontainatleastonedigit: "Le mot de passe doit contenir au moins un chiffre",
        yourpasswordshouldcontainatleastonelowercase: "Le mot de passe doivent contenir au moins une minuscule",
        yourpasswordmustcontainatleastonespecialcharacter: "Le mot de passe doit contenir au moins un caractère spécial",
        yourpasswordshouldcontainatleast8characters: "Le mot de passe doit contenir au moins 8 caractères",
        confirmationisrequired: "La confirmation du mot de passe est obligatoire",
        country: "Pays",
        phonenumber: "Numéro de téléphone",
        confirmationPasswordNotTheSame: "Le mot de passe de confirmation est incorrect",
        emailalreadyinuse: "Cette adresse électronique est déjà utilisée",
        wrongverificationcode: "Le code de vérification n'est pas le bon",
        inscriptionValidate: "Inscription terminée, vous allez être redirigé vers la page de connexion."
    },

    dashboard: {
        oragnizationCannotBeUsedRentalPeriod1: "Cette organisation : ",
        oragnizationCannotBeUsedRentalPeriod2: ", ne peut pas être utilisée car elle a atteint la fin de la période de location. Veuillez contacter UTC-SYSTEM pour obtenir de l'aide.",
        statusCard: {
            device: "Appareil",
            monitored: "Suivi",
            status: "Etat",
            critical: "Critique",
            warning: "Avertissement",
            ok: "Ok",
            maintenance: "Maintenance",
            batteryreplacementneeded: "remplacement(s) de batterie à prévoir",
            returnforcalibrationneeded: "recalibration(s) nécessaire(s)",
            no: "Pas de",
            renting: "Contrat de location",
            singleexpiration: "contrat en cours d'expiration ou expiré",
            multipleexpiration: "contrats en cours d'expiration ou expirés",
        },

        alarmsRecapCard: {
            alarmssummary: "Récapitulatif des alarmes",
            alarm: "alarme",
            compared: "comparé",
            tolastmonth: "au mois dernier",
            currentlyactive: "actuellement active(s)",
            notconsulted: "non consultée(s)",
            notificationsaresentto: "Notifications envoyées à",
            person: "personne",
            people: "personnes",
            manage: "Modifier",
            equal: "équivalent",
            day: "il y a",
            ago: "jour(s)",
            intrusion: "intrusion",
        },

        intrusionsRecapCard: {
            intrusionssummary: "Récapitulatif des intrusions",
            compared: "comparé",
            tolastmonth: "au mois dernier",
            currentlyactive: "actuellement active(s)",
            notconsulted: "non consultée(s)",
            notificationsaresentto: "Notifications envoyées à",
            person: "personne",
            people: "personnes",
            manage: "Modifier",
            equal: "équivalent",
            intrusion: "intrusion",
        },

        statistics: {
            statistics: "Statistiques",
            operatingtime: "Temps de fonctionnement",
            operating: "En fonctionnement",
            alarmperutc: "Alarme(s) par UTC",
            alarm:"Alarmes",
            incident:"Incidents",
            intrusion:"Intrusions",
            incidentperutc:"Incident(s) par UTC",
            noDataOperationTime: "Aucun UTC n'a encore fonctionné",
            noDataAlarmsCount: "Aucunes alarmes détectées à ce jour",
            noIncidents: "Aucuns incidents détectés à ce jour",
            time: "Temps (h)",
            network: "Déconnexions réseau",
            intrusionperutc: "Intrusion(s) par UTC",
            noIntrusions: "Aucunes intrusions détectées à ce jour",

        }
    },

    utc: {
        status: "Etat",
        critical: "Critique",
        warning: "Avertissement",
        addDevice: "Ajouter un appareil",
        deleteDevice: "Supprimer un appareil",
        ok: "Ok",
        rentalexpiration: "Expiration de la location",
        notrecommendedthreshold: "Seuil non recommandé",
        resetfilter: "Réinitialiser le filtre",
        batteryremplacementneeded: "Batterie à remplacer",
        maskedition:"Edition de Masques",
        thermographfeatures:"Fonctions Thermographe",
        signals:"Signaux",
        sortby: "Trier par",
        filterby: "Filtrer par",
        serialnb: "Numéro de Série - (Par défaut)",
        denomination: "Dénomination",
        distancecategory: "Catégorie",
        rangetype: "Type d'application",
        hardversion: "Version Hard",
        softversion: "Version Soft",
        newDeviceMax: "Impossible d'ajouter un appareil. Vous avez la limite maximale du nombre d'UTC autorisé dans cette organisation. Veuillez contacter UTC-SYSTEM pour obtenir de l'aide.", 
        rental: "Location",

        newDevice: {
            addDevice: "Ajouter un nouvel appareil",
            serialNb: "Numéro de série",
            mac: "Adresse MAC",
            orderNb: "Numéro de contrat",
            validate: "Valider",
            cancel: "Annuler",
            newDeviceOK: "Nouvel appareil ajouté", 
            newDeviceNOK: "Impossible d'ajouter un appareil. Il peut s'agir d'un SN incorrect, d'un SN déjà utilisé, d'un MAC incorrect, d'un contrat invalide (inexistant ou dont la date de location est dépassée).", 
        },

        delDevice: {
            delDevice: "Supprimer un appareil",
            serialNb: "Numéro de série",
            mac: "Adresse MAC",
            orderNb: "Numéro de contrat",
            validate: "Valider",
            cancel: "Annuler",
            deleteDeviceOK: "Appareil supprimé",
            deleteDeviceNOK: "Informations incorrectes pour supprimer un appareil de cette organisation",
        },

        utcCard: {
            emissivity: "Emissivité",
            triggerthreshold: "Seuil de déclenchement",
            settings:"Réglages",
            deviceCannotBeUsedRentalPeriod: "Cet appareil ne peut pas être utilisé car il a atteint la fin de la période de location. Veuillez contacter UTC-SYSTEM pour obtenir de l'aide.",
        },

        systemDataCard: {
            systemdata: "Données système",
            serialnumber: "Numero de série",
            category: "Catégorie",
            type: "Type d'application",
            hardversion: "Version hard",
            softversion: "Version soft",
        },

        batteryCard: {
            backupbattery: "Batterie de secours",
            nobattery: "Pas de batterie de secours",
            last: "Dernière",
            next: "Prochaine",
            utcpoweredbybatteries: "UTC alimenté par batterie",
        },

        fileCard: {
            filestorage: "Stockage de fichiers",
            hereitisthestoragespaceforonedocumentspecifictothisutctohelpyouspotoridentifyit: "Espace de stockage d'un document propre à cet UTC, afin de vous aider à l'identifier",
            dropyourfileorclickhere: "Déposez votre dossier ou cliquez ici",
            uploadthisdocument: "importer un fichier",
            delete: "Supprimer",
            download: "Télécharger",            
        },

        controlsCard: {
            permanent: 'Permanent',
            night: 'Nuit (22h - 6h)',
            progScreen: "Captures d'écran programmables",
            maskedition:"Edition de Masques",
            thermographoptions:"Fonctions Thermographe",
            signals:"Signaux",
            emissivity: "Emissivité",
            alarmparameters: "Paramètres d'alarme",
            thresholdInfo: "Examples :",
            thresholdInfo1: "Détection précoce d'incendie : 55°C",
            thresholdInfo2: "Equipement électrique : 75°C",
            advancedconfiguration: "Configuration avancée",
            threshold: "Seuil Système",
            trigger: "Déclenchement",
            every: "chaque",
            customization: "Personnalisation",
            degree: "Degré",
            frequency: "Fréquence",
            time: "Heure",
            language: "Language",
            minute: "minute",
            hour: "heure",
            day: "jour",
            week: "semaine",
            month: "mois (30)",
            denomination: "ID",
            reset: "Réinitialiser",
            save: "Enregistrer",
            sound: "Son",
            alarmindicator: "Visuel",
            multiplier: "Multiplicateur",
            takeapictureremotely: "Prendre une photo à distance",
            activateavisualeffectremotelyonutcahelptofindandidentifyit: "Activer un effet visuel à distance sur l'UTC, une aide pour le trouver et l'identifier",
            period: "Périodicité",
            advancedAlarmSettings: "Configuration des options avancées",
            entryDelay: "Délai d'entrée",
            exitDelay: "Délai de sortie",
            hysteresis: "Hystérésis",
            triggerthreshold: "Seuil de déclenchement",
            notifications: "Notifications",
            intrusionDetection: "Détection d'intrusion",
            warningnotif: "La désactivation de ce paramètre suspend toute notification sauf le mail d'alarme.",
            emissivityisrequired: "L'émissivité est requise",
            theemissivityvaluemustbeapositiverealnumber: "La valeur de l'émissivité doit être un nombre réel positif.",
            hysteresisisrequired: "L'hystérésis est requis",
            thehysteresisvaluemustbeapositiverealnumber: "La valeur de l'hystérésis doit être un nombre réel positif.",
            entryDelayisrequired: "Le délai d'entrée est requis",
            theentryDelayvaluemustbeapositiverealnumber: "La valeur du délai d'entrée doit être un nombre réel positif",
            exitDelayisrequired: "Le délai de sortie est requis",
            theexitDelayvaluemustbeapositiverealnumber: "La valeur du délai de sortie doit être un nombre réel positif",
            thresholdisrequired: "Le seuil est requis",
            thethresholdvaluemustbeapositiverealnumber: "La valeur du seuil doit être un nombre réel positif",
            thethresholdvaluemustbebetween: "La valeur seuil doit être comprise entre ",
            and: " et ",
            thetriggervaluemustbeapositiverealnumber: "Cette valeur doit être un nombre réel positif",
            theDelayvaluemustbeaninteger: "Cette valeur doit être un nombre entier",
            thetriggervaluemustbebetween: "La valeur de déclenchement doit être comprise entre ",
            denominationisrequired: "La dénomination est requise",
            intrusionparameters: "Paramètres intrusion",
            intrusion: "Intrusion",
            mode: "Mode",
            theEntryDelayvalueIntmustbebetween1and60: "La valeur du délai d'entrée doit être comprise entre 1 s et 60 s (1 min)",
            theExitDelayvalueIntmustbebetween10and600: "La valeur du délai de sortie doit être comprise entre 10 s et 600 s (10 min)",
            theEntryDelayvaluemustbebetween0and300: "La valeur du délai d'entrée doit être comprise entre 0 s et 300 s (5 min)",
            theExitDelayvaluemustbebetween0and604800: "La valeur du délai de sortie doit être comprise entre 0 s et 604800 s (1 semaine)",
            modeselectionlocked: "Cette fonctionalité n'est pas encore disponible.",
            theHysteresisvaluemustbebetween0and20: "La valeur de l' hysteresis doit être comprise entre 0 et 20",

            screenshotOrdersentOK: "La commande de screenshot a été envoyée",
            screenshotOrdersentERR: "Une erreur est survenue dans l'envoi de la commande screenshot",
            findmeOrdersentOK: "La commande de localisation a été envoyé",
            findmeOrdersentERR: "Une erreur est survenue dans l'envoi de la commande de localisation",
            updateSettingsOrdersentOK: "La commande des nouveaux paramètres a été envoyé",
            
            maskDetail: {
                takeapictureremotely: "Prendre une photo à distance",
                screenshotOrdersentOK: "La commande de screenshot a été envoyée",
                mask: "Masque",
                restrictAlarm: "Désactiver l'alarme",
                actions: "Actions",
                cancel: "Annuler",
                sendtoutc: "Envoyer à l'UTC",
                tenthofimage: "Un masque ne doit pas excéder 10% de l'image.",
                youwillexceedthenumberofauthorizedareas: "Vous ne pouvez pas créer plus de 5 masques.",
                yourorderhasbeensenttoUTC:"votre commande a bien été envoyé à l'UTC",
                yourordercouldnotbesenttoUTC:"votre commande n'a pas pu être envoyée à l'UTC",
                alertdelete:"Attention : La modification ou suppression d'un masque pourrait ne pas être visible immediatement sur l'image si celle-ci a été prise avec le masque que vous modifiez / supprimez.",
                pleaseconsider: "Veuillez envisager de prendre une nouvelle capture d'écran pour mettre à jour l'affichage.",
                createmaskinfo: "Créez un masque (rectangle) en cliquant sur l'image une fois pour le premier coin, puis une seconde fois pour le coin opposé.",
                maxsize: "Taille maximale d'un masque : 10% de l'image."
            },

            advancedOptionsDetail: {
                takeapictureremotely: "Prendre une photo à distance",
                screenshotOrdersentOK: "La commande de screenshot a été envoyée",
                addaregionofinterest: "Ajouter une region d'intérêt",
                addapointofinterest: "Ajouter un point d'intérêt",
                regionmanagement: "Gestion des régions",
                pointmanagement: "Gestion des points",
                deleteregion: "Supprimer la (les) region(s)",
                deletepoint: "Supprimer le(s) point(s)",
                alertmanagement: "Gestion des alertes",
                thresholdexceedancealert: "Alerte sur dépassement de seuil",
                threshold: "Seuil",
                deletethresholdexceedancealert: "Supprimer l'alerte sur dépassement de seuil",
                temperaturedifferencealert: "Alerte sur écart de température",
                difference: "Ecart",
                deletetemperaturedifferencealert: "Supprimer l'alerte sur écart de température",
                cancel: "Annuler",
                sendtoutc: "Envoyer à l'UTC",
                youwillexceedthenumberofauthorizedareas: "Vous ne pouvez pas créer plus de 5 régions",
                youwillexceedthenumberofauthorizedpoints: "Vous ne pouvez pas créer plus de 10 points",
                nothresholdexceedancealert: "Aucune alerte sur dépassement de seuil",
                notemperaturedifferencealert: "Aucune alerte sur écart de température",
                thethresholdvaluemustbeapositiveintegernumber: "La valeur de seuil doit être un nombre entier positif.",
                thegapvaluemustbeapositiveintegernumber: "La valeur de l'écart doit être un nombre entier positif.",
                youhavetochooseatleast2items: "Vous devez choisir au moins 2 éléments",
                atleastoneoftheregionstobedeleted: "Au minimum une des régions à supprimer est associée à une alerte. Pour supprimer la région, merci de modifier / supprimer la (les) alerte(s) concernée(s).",
                atleastoneofthepointstobedeleted: "Au minimum un des points à supprimer est associé à une alerte. Pour supprimer le point, merci de modifier / supprimer la (les) alerte(s) concernée(s).",
                yourorderhasbeensenttoUTC: "Votre commande a bien été envoyé à l'UTC",
                yourordercouldnotbesenttoUTC: "Votre commande n'a pas pu être envoyée à l'UTC",
                avalueisrequired: "Une valeur est requise",
                anerrorexistsinalertsconfiguration: "Une erreur existe dans la configuration des alertes (régions ou points). Veuillez vérifier que tous les champs sont correctement remplis et réessayez.",
                createregioninfo: "Créez une région (rectangle) en cliquant une fois sur l'image pour le premier coin, puis une seconde fois pour le coin opposé.",
                createpointinfo: "Créez un point en cliquant sur l'image à l'endroit désiré.",
                reminder: 'Rappel de bon usage pour les écarts de température',
                gap0: 'Ecart',
                gap1: 'X < 10°C',
                gap2: '10°C < X < 20°C',
                gap3: '20°C < X < 40°C',
                gap4: 'X > 40°C',
                time0: 'Temps d\'action',
                time1: '~ 6 mois',
                time2: '~ 3 mois',
                time3: '~ 1 mois',
                time4: '~ 1 semaine',
            }
        },

        environmentalMetricsCard: {
            temperature: "Température",
            supply: "Alimentation",
            inside: "Interne",
            outside: "Externe",
            connected: "Connecté",
            not: "Non",
            connection: "Connexion",
            operatingtime: "Temps de fonctionnement",
            utcconnectionstatus: "Etat de connexion de l'UTC",
            utcinternaltemperature: "Température interne  de l'UTC",
            utcsupplymonitoring: "Etat de l'alimentation de l'UTC",
            externaltemperatureonthefrontofutcscenedirection: "Température externe sur la face avant de l'UTC",
            totaloperatingtimesincefirstuse: "Temps total d'utilisation depuis la première utilisation"
        },
    },

    alarm: {
        search: "Recherche",
        filterby: "Filtrer par",
        alarmactive: "Alarme active",
        alarmnotconsulted: "Alarme non consultée",
        selectanalarmfolder: "Sélectionnez un dossier d'alarme",
        january: "Janvier",
        february: "Fevrier",
        march: "Mars",
        april: "Avril",
        may: "Mai",
        june: "Juin",
        july: "Juillet",
        august: "Août",
        september: "Septembre",
        october: "Octobre",
        november: "Novembre",
        december: "Decembre",
        before: "Avant",
        alarm: "alarme",

        alarmDetailsCard: {
            masksexcluded: "Masques exclus",
            masksincluded: "Masques inclus",
            notavailable: "Non disponible",
            time: "Heure",
            thisalarmisactive: "Cette alarme est active",
            environment: "Environnement",
            temperature: "Température",
            humidity: "Humidité",
            configuration: "Configuration",
            triggerthreshold: "Seuil de déclenchement",
            emissivity: "Emissivité",
            inalarm: "En alarme",
            internal: "Interne",
            fpatemperature: "Température FPA",
            measuredtemperatures: "Températures mesurées",
            measurements: "Mesures",
            acknowledge: "Acquittement",
            download: "Télécharger",
            cursortemperature: "Température du curseur",
            cursortooltip: "Cliquer sur l'image afin de connaitre la temperature à un endroit en particulier",
            regionsdata: "Données des régions",
            region: "Région",
            pointsdata: "Données des points",
            value: "Valeur",
            alertrules: "Règles d'alerte",
            difference: "Ecart",
            in: "entre"
        }
    },

    intrusion: {
        search: "Recherche",
        filterby: "Filtrer par",
        intrusionactive: "Intrusion active",
        intrusionnotconsulted: "Intrusion non consultée",
        selectanintrusionfolder: "Sélectionnez un dossier de détection d'intrusion",
        notconsulted: "non consultée(s)",
        active: "active(s)",
        january: "Janvier",
        february: "Fevrier",
        march: "Mars",
        april: "Avril",
        may: "Mai",
        june: "Juin",
        july: "Juillet",
        august: "Août",
        september: "Septembre",
        october: "Octobre",
        november: "Novembre",
        december: "Decembre",
        before: "Avant",
        intrusion: "intrusion",

        intrusionDetailsCard: {
            notavailable: "Non disponible",
            time: "Heure",
            thisintrusionisactive: "Cette détection d'intrusion est active",
            environment: "Environnement",
            temperature: "Température",
            humidity: "Humidité",
            configuration: "Configuration",
            triggerthreshold: "Seuil de déclenchement",
            emissivity: "Emissivité",
            inintrusion: "En état d'intrusion",
            internal: "Interne",
            fpatemperature: "Température FPA",
            measuredtemperatures: "Températures mesurées",
            measurements: "Mesures",
            masksexcluded: "Masques exclus",
            masksincluded: "Masques inclus",
            acknowledge: "Acquittement",
            download: "Télécharger",
            cursortemperature: "Température du curseur",
            cursortooltip: "Cliquer sur l'image afin de connaitre la temperature à un endroit en particulier",
            regionsdata: "Données des régions",
            region: "Région",
            pointsdata: "Données des points",
            value: "Valeur",
            alertrules: "Règles d'alerte",
            difference: "Ecart",
            in: "entre",
            basicinformations: "Informations générales"
        }
    },

    screenshots: {
        selectascreenshot: "Selectionnez une capture d'écran ",
        search: "Recherche",
        january: "Janvier",
        february: "Fevrier",
        march: "Mars",
        april: "Avril",
        may: "Mai",
        june: "Juin",
        july: "Juillet",
        august: "Août",
        september: "Septembre",
        october: "Octobre",
        november: "Novembre",
        december: "Decembre",
        before: "Avant",
        screenshots: "capture(s) d'écran",

        screenshotDetailsCard: {
            masksexcluded: "Masques exclus",
            masksincluded: "Masques inclus",
            notavailable: "Non disponible",
            time: "Heure",
            alertscreenshot: "Capture d'écran d'alerte",
            manualscreenshot: "Capture d'écran manuelle",
            programmablescreenshot: "Capture d'écran programmée",
            environment: "Environnement",
            temperature: "Température",
            humidity: "Humidité",
            configuration: "Configuration",
            triggerthreshold: "Seuil de déclenchement",
            emissivity: "Emissivité",
            inalarm: "En alarme",
            internal: "Interne",
            fpatemperature: "Température FPA",
            measuredtemperatures: "Températures mesurées",
            measurements: "Mesures",
            cursortooltip: "Cliquer sur l'image afin de connaitre la temperature à un endroit en particulier",
            cursortemperature: "Température du curseur",
            download: "Télécharger",
            delete: "Supprimer",
            regionsdata: "Données des régions",
            region: "Région",
            pointsdata: "Données des points",
            value: "Valeur",
            alertrules: "Règles d'alerte",
            difference: "Ecart",
            in: "entre"
        }
    },

    users: {
        role: "Rôle",
        search: "Recherche",
        invite: "Inviter",
        username: "Nom d'utilisateur",
        email: "Adresse électronique",
        phonenumber: "Numéro de téléphone",
        country: "Pays",
        phone: "Téléphone",
        invitationStatus: "Statut d'invitation",
        notifications: "Notifications",
        actions: "Actions",
        cancel: "Annuler",
        validate: "Valider",
        newuser: "Inviter un nouvel utilisateur",
        newUserOK: "Nouvel utilisateur invité",
        edituser: "Modifier l'utilisateur",
        deleteUserOK: "L'utilisateur a correctement été supprimé.",
        editUserOK: "Vos modifications ont été enregistrées.",
        nameisrequired: "Le nom est requis",
        emailisrequired: "L'adresse électronique est obligatoire",
        emailmustbevalid: "L'adresse électronique doit être valide",
        emailalreadyinuse: "Cette adresse électronique est déjà utilisée",
        roleRequired: "Le rôle est obligatoire",
        areyousureyouwanttodeletethisuser: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
        thisuserwillnotbeabletoreconnect: "Cet utilisateur ne pourra pas se reconnecter à l'organisation.",
        ok: "Ok",
        event: "Évènement",
        warning: "Attention : la notification via SMS génère des coûts supplémentaires.",
        sendmail:"Envoi de Mail",
        sendSMS:"Envoi de SMS",
        validateOK: "Vos modifications ont été enregistrées.",
        info:"L’apparition de cet évènement génère, dans sa configuration minimale, une notification par mail.",
        notifutc:"La notification par mail de cet évènement n’est pas impactée par le paramétrage des UTC.",
        required: "Champ requis",
        nb1:"L’envoi de notifications par un UTC est dépendant de l’activation du paramètre « Notifications » de cet UTC (onglet « UTC »).",
        emailAlreadyExistOnThisOrganization: "Cet utilisateur (adresse email) existe déjà dans cette organisation.",
        nb2:"La désactivation de ce paramètre suspend l’envoi de toutes les notifications d’un UTC sauf la notification par mail en cas d’alarme et d'intrusion."
    },

    account: {
        modify: "Modifier",
        password: "Mot de passe",
        reset: "Réinitialiser",
        save: "Enregister",
        username: "Nom d'utilisateur",
        email: "Adresse électronique",
        phonenumber: "Numéro de Téléphone",
        usernameisrequired: "Le nom d'utilisateur est requis",
        changesOK: "Vos modifications ont été enregistrées.",
        emailChangesOK: "Votre adresse email a été modifiée",
        phoneChangesOK: "Votre numéro de téléphone a été modifié",
        event: "Évènement",
        warning: "Attention : la notification via SMS génère des coûts supplémentaires.",
        info:"L’apparition de cet évènement génère, dans sa configuration minimale, une notification par mail.",
        notifutc:"La notification par mail de cet évènement n’est pas impactée par le paramétrage des UTC.",
        required: "Champ requis",
        nb1:"L’envoi de notifications par un UTC est dépendant de l’activation du paramètre « Notifications » de cet UTC (onglet « UTC »).",
        nb2:"La désactivation de ce paramètre suspend l’envoi de toutes les notifications d’un UTC sauf la notification par mail en cas d’alarme et d'intrusion.",
        sendmail:"Envoi de Mail",
        sendSMS:"Envoi de SMS",
        organization: "Organisation : ",
        role: "Rôle : ",
        oragnizationCannotBeUsedRentalPeriod1: "Cette organisation : ",
        oragnizationCannotBeUsedRentalPeriod2: ", ne peut pas être utilisée car elle a atteint la fin de la période de location. Veuillez contacter UTC-SYSTEM pour obtenir de l'aide.",
        phonenumberisrequiredtoreceivesms: "Vous n'avez pas renseigné de numéro de téléphone, cependant des notification par SMS vous sont configurées dans au moins une organisation.",

        changeMail: {
            mailchange: "Modification de l'adresse mail",
            newMail: "Nouvelle adresse mail",
            verificationCode: "Code de vérification",
            save: "Enregister",
            cancel: "Annuler",
            emailisrequired: "L'adresse électronique est requise",
            emailmustbevalid: "L'adresse électronique doit être valide",
            emailalreadyinuse: "Cette adresse électronique est déjà utilisée",
            wrongverificationcode: "Le code de vérification n'est pas le bon",
        },

        changePassword: {
            passwordchange: "Modification du mot de passe",
            currentpassword: "Mot de passe actuel",
            newpassword: "Nouveau mot de passe",
            passwordconfirmation: "Confirmation du mot de passe",
            save: "Enregister",
            cancel: "Annuler",
            actualpasswordisrequired: "Le mot de passe actuel est requis",
            passwordisrequired: "Le nouveau mot de pase est obligatoire",
            yourpasswordshouldcontainatleastoneuppercase: "Le mot de passe doit contenir au moins une majuscule",
            yourpasswordshouldcontainatleastonedigit: "Le mot de passe doit contenir au moins un chiffre",
            yourpasswordshouldcontainatleastonelowercase: "Le mot de passe doivent contenir au moins une minuscule",
            yourpasswordmustcontainatleastonespecialcharacter: "Le mot de passe doit contenir au moins un caractère spécial",
            yourpasswordshouldcontainatleast8characters: "Le mot de passe doit contenir au moins 8 caractères",
            confirmationisrequired: "La confirmation du mot de passe est obligatoire",
            youenteredabadcurrentpassword: "Votre mot de passe actuel n'est pas correct",
            yournewpassworddoesntmatchwithpasswordconfirmation: "Votre nouveau mot de passe ne correspond pas à la confirmation du mot de passe.",
            yournewpasswordisthesamethanthecurrentone: "Votre nouveau mot de passe et votre ancien mot de passe sont identiques",
            passwordChangedOK: "Votre mot de passe a bien été mis à jour.Vous allez être déconnecté.",
        },

        changePhoneNumber: {
            phonechange: "Modification du numéro de téléphone",
            save: "Enregister",
            cancel: "Annuler",
            country: "Pays",
            phonenumber: "Numéro de Téléphone",
        },

        newPassword: {
            newpassword: "Nouveau mot de passe",
            passwordconfirmation: "Confirmation du mot de passe",
            validate: "Valider",
            cancel: "Annuler",
            passwordisrequired: "Le nouveau mot de pase est obligatoire",
            yourpasswordshouldcontainatleastoneuppercase: "Le mot de passe doit contenir au moins une majuscule",
            yourpasswordshouldcontainatleastonedigit: "Le mot de passe doit contenir au moins un chiffre",
            yourpasswordshouldcontainatleastonelowercase: "Le mot de passe doivent contenir au moins une minuscule",
            yourpasswordmustcontainatleastonespecialcharacter: "Le mot de passe doit contenir au moins un caractère spécial",
            yourpasswordshouldcontainatleast8characters: "Le mot de passe doit contenir au moins 8 caractères",
            confirmationisrequired: "La confirmation du mot de passe est obligatoire",
            yournewpassworddoesntmatchwithpasswordconfirmation: "Votre nouveau mot de passe ne correspond pas à la confirmation du mot de passe.",
        },

        requestNewPassword: {
            email: "Adresse électronique",
            validate: "Valider",
            cancel: "Annuler",
        },
    },


    invite: {
        required: "Champ requis",
        username: "Nom d'utilisateur",
        email: "Adresse électronique",
        phonenumbermustbevalid: "Le numéro de téléphone doit être valide",
        newpassword: "Nouveau mot de passe",
        passwordconfirmation: "Confirmation du mot de passe",
        validate: "Valider",
        cancel: "Annuler",
        nameisrequired: "Le nom est requis",
        passwordisrequired: "Le nouveau mot de pase est obligatoire",
        yourpasswordshouldcontainatleastoneuppercase: "Le mot de passe doit contenir au moins une majuscule",
        yourpasswordshouldcontainatleastonedigit: "Le mot de passe doit contenir au moins un chiffre",
        yourpasswordshouldcontainatleastonelowercase: "Le mot de passe doivent contenir au moins une minuscule",
        yourpasswordmustcontainatleastonespecialcharacter: "Le mot de passe doit contenir au moins un caractère spécial",
        yourpasswordshouldcontainatleast8characters: "Le mot de passe doit contenir au moins 8 caractères",
        confirmationisrequired: "La confirmation du mot de passe est obligatoire",
        onSupervision: "Vous êtes maintenant inscrit sur UTC-SUPERVISION, vous allez être redirigé vers la page de connexion.",
        onOrgaSupervision: "Vous faites désormais partie d'une nouvelle organisation.",
    },


    organization: {
        validate: "Valider",
        cancel: "Annuler",
        save: "Enregister", 
        reset: "Réinitialiser",
        changesOK: "Vos modifications ont été enregistrées.",
        createOrga: "Créer une Orga",
        deleteOrga: "Supprimer une Orga",
        changeOrgaNameFrom: "Changer le nom de l'organisation : ",

        newOrga: {
            addOrga: "Créer une nouvelle organisation",
            name: "Nom de l'organisation",
            orderNb: "Numéro de commande",
            validate: "Valider",
            cancel: "Annuler",
            newOrgaOK: "Nouvelle organisation créée.",
            newOrgaNOK: "Impossible de créer cette organisation. Verifiez que le numéro de commande est valide.",
            newOrgaDuplicate: "Cette organisation existe déjà pour ce numéro de commande",
        },

        delOrga: {
            delOrga: "Supprimer une organisation",
            name: "Nom de l'organisation",
            orderNb: "Numéro de commande",
            validate: "Valider",
            cancel: "Annuler",
            delOrgaOK: "l'organisation à été supprimée.",
            delOrgaNOK: "Impossible de supprimer cette organisation."
        }
    },
    

    support: {
        contactus: "Nous contacter",
        reportaproblem: "Signaler un problème",
        category: "Catégorie",
        utcsensor: "UTC",
        webpage: "Page Web",
        othersubject: "Autre sujet",
        subject: "Sujet",
        yourmessage: "Votre message",
        fileinput: "Pièce(s) jointe(s)",
        report: "Signaler",
        categoryisrequired: "La catégorie est requise",
        subjectisrequired: "Le sujet est requis",
        messageisrequired: "Le message est requis",
        supportmailOK: "Votre message a été envoyé. Vous recevrez une réponse dans les plus brefs délais.",
        supportmailNOK: "Votre message n'a pas pu être envoyé. Veuillez réessayer plus tard",
    },
}
